import React from "react";
import { isMobile } from "react-device-detect";
import { useCursorContext } from "../context/CursorContext";
import { useTheme } from "../context/ThemeContext";

const Cursor: React.FC = () => {
  // Custom cursor context
  const { dot, cursor } = useCursorContext();

  // Theme context
  const { theme } = useTheme();
  const isDark = theme === "dark";

  // In dark mode, all pages become dark — use light cursor everywhere.
  // In light mode, all pages become light — use dark cursor everywhere.
  const onDarkBackground = isDark;

  // Determine the cursor image based on background and cursor type
  const getCursorImage = () => {
    if (cursor === "default") {
      return onDarkBackground ? "cursorDefaultColored.png" : "cursorDefault.png";
    } else {
      return onDarkBackground ? "cursorPointerColored.png" : "cursorPointer.png";
    }
  };

  return (
    // Hide cursor for mobile devices
    <div className={`${isMobile ? "hidden" : "block"}`}>
      <img
        ref={dot}
        src={getCursorImage()}
        className="cursor-dot relative z-50"
        alt={`${cursor === "default" ? "Default" : "Pointer"} Cursor`}
      />
    </div>
  );
};

export default Cursor;
